<template>
  <div ref="rootElement">
    <div class="zt-input-main w-full flex" :class="[textColorClasses, inputClasses]" :style="[textColorStyle]">
      <div v-if="prependOuterIcon && !appendOuterIcon" class="px-2 flex items-center justify-center">
        <zt-icon :name="prependOuterIcon" class="text-zt-xl" />
      </div>
      <div class="zt-input-slot w-full relative flex items-center">
        <div v-if="prependIcon && !appendIcon" class="zt-input-prepended-icon flex justify-center"
          :class="{ 'zt-input-appended-icon-disabled': isDisabled }">
          <zt-icon :name="prependIcon" />
        </div>
        <fieldset v-if="outlined" aria-hidden="true"
          class="border-zt-xs border-solid border-zt-dark-300 absolute left-0 bottom-0 right-0 pointer-events-none border-collapse"
          :class="{ 'zt-input-border-danger': redIfError }">
          <legend class="text-left p-0" :style="{ width: legendWidth }">
            <span>&#8203;</span>
          </legend>
        </fieldset>
        <div class="zt-input-text-field flex flex-auto items-center relative">
          <label :for="componentId" :class="[labelClasses, { 'zt-input-text-danger': redIfError }]" ref="ztInputLabel"
            class="zt-label absolute pointer-events-none block text-zt-dark-300 truncate">{{ label }}</label>
          <input ref="ztInput" class="zt-input w-full outline-none bg-transparent text-zt-dark-500 flex flex-auto"
            placeholder=" " name="zt-input-file" :id="componentId" :value="textFieldValue" autocomplete="off"
            autocapitalize="off" spellcheck="off" v-bind="$attrs" v-on="$listeners" @focus="_onFocus" @blur="_onBlur" @input="onInput" @click="_onClick" :style="textFieldValue ? 'display: none;' : ''" />
          <zt-chip v-if="textFieldValue" @click:close="cleanValue" color="primary-100"
            :class="{ 'zt-input-chip-danger': redIfError }" closable close-icon="close-rounded" square
            style="height: 26px;">
            {{ getFileName }}
          </zt-chip>
          <input ref="inputFile" type="file" id="file-input" style="display:none;" v-bind="$attrs" v-on="$listeners" @change="_onChange" :accept="filetypes">
        </div>
        <div v-if="appendIcon" class="zt-input-appended-icon flex justify-center"
          :class="{ 'zt-input-appended-icon-disabled': isDisabled }">
          <zt-icon :name="appendIcon" />
        </div>
      </div>
      <div v-if="appendOuterIcon" class="px-2 flex items-center justify-center">
        <zt-icon :name="appendOuterIcon" class="text-zt-xl" />
      </div>
    </div>
    <div class="flex">
      <div class="flex flex-auto relative justify-start mt-2" :class="prependOuterIcon ? 'ml-12' : ''">
        <slot name="message" />
      </div>
      <div class="flex flex-auto relative justify-end mt-2" :class="appendOuterIcon ? 'mr-12' : ''">
        <span class="text-zt-dark-400 text-zt-xs">{{ getFileSize }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztInputFile',
  inheritAttrs: false,
}
</script>


